import React from "react";
import ReactPaginate from "react-paginate";

const PaginatedButtons = ({ currentPage, perPage, total, onPageChange, className = "" }) => {
  // https://github.com/AdeleD/react-paginate/issues/167#issuecomment-388386261
  const onChange = ({ selected }) => onPageChange(+selected + 1);
  const pageCount = Math.ceil(total / perPage);

  return (
    <div className={`paginated-btn-container ${className}`}>
      <ReactPaginate
        breakLabel="..."
        nextLabel="NEXT"
        onPageChange={onChange}
        pageRangeDisplayed={4}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        previousLabel="PREV"
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default PaginatedButtons;
